import { Card, CardBody, Col, Row } from "reactstrap";
import ProfileLayout from "../../layouts/ProfileLayout";
import DefaultButton from "../../components/Buttons/Default";
import './styles.css';
import { FiUser } from "react-icons/fi";
import { FaInstagram, FaCamera } from "react-icons/fa";
import { PiPhoneList } from "react-icons/pi";
import { MdOutlineSegment } from "react-icons/md";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import ProfileSettingsModal from "../../components/Modals/ProfileSettings";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { LuPencil } from "react-icons/lu";
import { BsBuildings } from "react-icons/bs";
import OfficeSettingsModal from "../../components/Modals/OfficeSettings";
import { useTranslation } from "react-i18next";

function ProfilePage() {
  const { t } = useTranslation();
  const [profileSettingsModalShown, setProfileSettingsModalShown] = useState(false);
  const [officeSettingsModalShown, setOfficeSettingsModalShown] = useState(false);
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const [profilePicture, setProfilePicture] = useState(null);

  const handleProfilePictureChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProfilePicture(e.target.files[0]);
    }
  };

  const uploadProfilePicture = async () => {
    if (!profilePicture) return;

    const formData = new FormData();
    formData.append('profile_picture', profilePicture);

    const response = await fetch(API_URL + '/user/account/profile_picture/update', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('user', JSON.stringify(data.user));
      }
    } else {
      alert('خطأ في رفع الصورة');
    }
  };

  useEffect(() => {
    if (profilePicture) {
      uploadProfilePicture();
    }
  }, [profilePicture]);

  return (
    <ProfileLayout>
      <Row className="align-items-center">
        <Col md="8">
          <h4 className="mb-0">{ t('profile.title') }</h4>
        </Col>
        <Col md="4" className="text-md-end mt-3 mt-md-0">
          <Link to="/plans">
            <DefaultButton>{ t('profile.add_balance') }</DefaultButton>
          </Link>

          {Number(user?.is_office) === 1 ?
            <DefaultButton className="ms-2" color="warning" onClick={() => setOfficeSettingsModalShown(true)}>
              <BsBuildings className="me-1" />
              { t('profile.office') }
            </DefaultButton>
          :
            ''
          }
        </Col>
      </Row>

      <Card className="profile-header border mt-4">
        <CardBody className="d-flex flex-column flex-md-row align-items-center gap-3 gap-md-4">
          <div className="avatar-wrap">
            <img
              className="avatar-img"
              src={
                profilePicture
                  ? URL.createObjectURL(profilePicture)
                  : user?.profile_picture_path
                    ? STORAGE_URL + user.profile_picture_path
                    : require('../../assets/images/default-user.png')
              }
              alt="avatar"
            />
            <button
              className="avatar-edit-btn"
              onClick={() => document.getElementById('profile-picture-input').click()}
              title="تعديل الصورة"
            >
              <FaCamera size={14}/>
            </button>
            <input
              type="file"
              className="d-none"
              id="profile-picture-input"
              accept="image/*"
              onChange={handleProfilePictureChange}
            />
          </div>

          <div className="flex-fill text-center text-md-start">
            <h5 className="mb-1 profile-name">{user?.name || '—'}</h5>
            <p className="mb-3 small text-muted">{user?.email}</p>
            <DefaultButton size="sm" onClick={() => setProfileSettingsModalShown(true)}>
              <LuPencil className="me-1" />
              { t('profile.edit_profile') }
            </DefaultButton>
          </div>
        </CardBody>
      </Card>

      <Card className="mt-4 border">
        <CardBody>
          <Row className="gy-3">
            <Col md="6">
              <label className="field-label"><FiUser className="me-1" /> { t('profile.fullname') }</label>
              <div className="field-value">{user?.name || '—'}</div>
            </Col>
            <Col md="6">
              <label className="field-label"><PiPhoneList className="me-1" /> { t('profile.phone_number') }</label>
              <div className="field-value">{user?.phone_number || '—'}</div>
            </Col>
            <Col md="6">
              <label className="field-label"><FaInstagram className="me-1" /> { t('profile.instagram') }</label>
              <div className="field-value">{user?.instagram_link || '—'}</div>
            </Col>
            <Col md="6">
              <label className="field-label"><MdOutlineSegment className="me-1" /> { t('profile.description') }</label>
              <div className="field-value">{user?.bio || '—'}</div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="text-center mt-4">
        <Link to="/contact" className="text-danger small">{ t('profile.delete_account') }</Link>
      </div>

      <ProfileSettingsModal
        isOpen={profileSettingsModalShown}
        toggle={() => setProfileSettingsModalShown(!profileSettingsModalShown)}
        user={JSON.parse(localStorage.getItem('user')) || {}}
      />

      <OfficeSettingsModal 
        isOpen={officeSettingsModalShown}
        toggle={() => setOfficeSettingsModalShown(!officeSettingsModalShown)}
        user={JSON.parse(localStorage.getItem('user')) || {}}
      />
    </ProfileLayout>
  );
}

export default ProfilePage;